import { Paper, PaperProps, useTheme } from '@mui/material';

const ReviewCard = (props: PaperProps): JSX.Element => {
  const theme = useTheme();
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        minWidth: 363,
        maxWidth: 363,
        minHeight: 167,
        maxHeight: 167,
        cursor: 'pointer',
        ':hover': { bgcolor: theme.palette.action.hover },
      }}
      {...props}
    />
  );
};

export default ReviewCard;
